(function() {
angular.module('app.ui.form.ctrls')
.controller('CreateProfileModalCtrl', [
    '$scope',
    '$log',
    '$modalInstance',
    'practicesService',
    'data',
    'logger',
    function($scope, $log, $modalInstance, practicesService, data, logger) {
      $scope.data = [];
      $scope.data = data.data;
      $scope.showLocations = false;
      $scope.showPractices = false;
      $scope.showCategories = false;
      $scope.showJurisdictions = false;
      $scope.jurisdictions = [];
      $scope.element = data.element;
      $scope.heading = '';
      $scope.CheckBox = '';
      $scope.updatedData = {
        data: $scope.data,
        element: $scope.element
      };
      $scope.selectedAll = false;
      $scope.count = 0;

      $scope.saveButtonText = 'save';

      // This method hides all the components(locations, Practice Areas, jurisdictions, categories)
      // available in the modal
      function hideAllModalComponents(){
        angular.extend($scope, {
          showLocations: false,
          showPractices:false,
          showCategories: false,
          showJurisdictions: false
        });
      }

      // This Method gets the value for a property from the input object i.e data.data
      // used as an input model for the modal, if not found just returns the default
      // data object
      function getDataPropertyFromInputModel(property){ return (data.data[property] || data.data); }

      // This Method gets the value for the object used as a model to save temporarily
      // the selection made by the user
      function getUpdatedObjectForHoldingDataForSelection(elementId){
        switch(elementId){
          case 'jurisdiction':
            $scope.updatedData.otherJurisdictions = !_.isEmpty(data.otherJurisdictions) ? data.otherJurisdictions: '';
            $scope.jurisdictions = getDataPropertyFromInputModel('jurisdictions');
            return $scope.jurisdictions;
          case 'practice': return getDataPropertyFromInputModel('practiceAreas');
          case 'location': return getDataPropertyFromInputModel('locations');
          default: return getDataPropertyFromInputModel(null);
        }
      }

      // This method transitions the data for locations/Practice Areas to edit when user
      // either opens this modal for practice ares or presses the next button on the
      // Practice Area Settings
      function updateModalForNextFunctionality(elementId){
        $scope.saveButtonText = 'Next';
        $scope.data = getUpdatedObjectForHoldingDataForSelection(elementId);
        $scope.updatedData.data = $scope.data;

        // set the response object to be sent back as the updated data
        angular.extend($scope.updatedData, getUpdatedResponseModelNextFunctionality());
      }

      // This method updates the object that is to be returned when user has finished updating
      // either locations or the practicr areas
      function getUpdatedResponseModelNextFunctionality(){
        if($scope.showJurisdictions) {
          return {
            jurisdictions: $scope.updatedData.data,
            element: 'jurisdiction'
          };
        }
        else if($scope.showPractices) {
          return {
            practiceAreas: $scope.updatedData.data,
            element: 'practice'
          };
        }
        else if($scope.showLocations) {
          return {
            locations: $scope.updatedData.data,
            element: 'location'
          };
        }
      }

      // This methd updates modal for the locations settings
      function askToSelectLocations(){
        hideAllModalComponents();
        $scope.heading = 'createProfile.locationsModal.Heading';
        $scope.subHeading = 'createProfile.locationsModal.subHeading';

        $scope.showLocations = true;
        $scope.isHeadingBold = true;

        //ask to update data for locations change
        updateModalForNextFunctionality('location');
      }

      // This methd updates modal for the Practice Area settings
      function askToSelectPracticeAreas(){
        hideAllModalComponents();
        $scope.heading = 'createProfile.practiceAreasModal.Heading';
        $scope.subHeading = 'createProfile.practiceAreasModal.subHeading';

        $scope.showPractices = true;
        $scope.isHeadingBold = true;

        //ask to update data for Practice Areas change
        updateModalForNextFunctionality('practice');

        //count the already selected Practice Areas
        data.linearPractices.forEach(function(practice, index, array) {
          if (practice.isSelected && !practice.hasChild) {
            $scope.count++;
          }
        });
      }

      // This methed updates modal for the Jurisdiction selection settings
      function askToSelectJurisdictions(){
        hideAllModalComponents();
        $scope.element = 'jurisdiction';
        $scope.heading = 'createProfile.jurisdictionsModal.Heading';
        $scope.subHeading = 'createProfile.jurisdictionsModal.subHeading';

        $scope.showJurisdictions = true;
        $scope.isHeadingBold = true;

        updateModalForNextFunctionality('jurisdiction');
      }

      // find and set the values for the practice areas that are changed,
      // This value is to be returned as the changed selection made by the user
      function determineChangedPractices(){
        $scope.updatedData.linearPractices = [];
        $scope.updatedData.data.forEach(function(law_area, index, array) {
          $scope.updatedData.linearPractices.push(law_area);
          law_area.practices.forEach(function(practice, index, array) {
            $scope.updatedData.linearPractices.push(practice);
            practice.sub_areas.forEach(function(sub, index, array) {
              return $scope.updatedData.linearPractices.push(sub);
            });
          });
        });
      }

      // This method return a data when the modal is closed, if no data is given i.e canceled
      // it just closes without returning any thing
      function closeModalWithData(newData){$modalInstance.close(newData);}

      // This method prepares data & UI to display for the next selection
      function displayNextSelection(){
        $scope.hasUserMadeAnyUpdates = true;

        if ($scope.updatedData.element === 'jurisdiction') { askToSelectPracticeAreas();}
        else if ($scope.updatedData.element === 'practice') {
          determineChangedPractices();
          askToSelectLocations();
        }
        else closeModalWithData($scope.updatedData);
      }

      // This method determines whether the modal has been asked to activate the
      // multiple selection views one by one or is it to just behave like a single popup
      function determineWhetherToDisplayNextSelectionOrClose(){
        if(data.displayNextFunctionality) displayNextSelection();
        else  closeModalWithData($scope.updatedData);
      }

      $scope.displayChildLocations = function(region) {
        return region.showChildLocations = true;
      };
      $scope.hideChildLocations = function(region) {
        return region.showChildLocations = false;
      };
      $scope.isHeadingBold = false;

      //determine whether to display the Jurisdictions for editing
      if ($scope.element === 'jurisdiction') askToSelectJurisdictions();
      //determine whether to display the Practice Areas for editing
      else if ($scope.element === 'practice') askToSelectPracticeAreas();
      //determine whether to display the locations for editing
      else if ($scope.element === 'location') askToSelectLocations();
      else if ($scope.element === 'category') {
        $scope.heading = 'createProfile.firmCategoryModal.Heading';
        $scope.subHeading = 'createProfile.firmCateforyModal.subHeading';
        $scope.showCategories = true;
      }

      $scope.updateData = function(event, cur_box) {
        var message, value;
        if ($scope.showLocations) {
          $scope.updatedData.element = $scope.element;
          value = event.target.checked;
          $scope.updatedData.data.forEach(function(chkbox, index, array) {
            if (chkbox.loc_ID === cur_box.loc_ID) {
              chkbox.isSelected = value;
            }
          });
        } else if ($scope.showJurisdictions) {
          $scope.updatedData.element = $scope.element;
          value = event.target.checked;
          $scope.updatedData.data.forEach(function(chkbox, index, array) {
            if (chkbox.loc_ID === cur_box.loc_ID) {
              chkbox.isSelected = value;
            }
          });
        } else if ($scope.showPractices) {
          $scope.updatedData.element = $scope.element;
          value = event.target.checked;
          if (value) {
            $scope.count++;
            if ($scope.count > 20) {
              message = 'You are allowed to choose a maximum of 20 practice areas.';
              logger.notify('error', message);
              event.target.checked = false;
              value = false;
              $scope.count = 20;
            } else if ($scope.count === 15) {
                message = 'You are approaching the limit for practice area selections.';
                logger.notify('warning', message);
            } else if ($scope.count === 20) {
                message = 'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.';
                logger.notify('warning', message);
            }
          } else {
            $scope.count--;
          }
          if ($scope.count <= 20) {
            $scope.updatedData.data.forEach(function(chkbox, index, array) {
              if (chkbox.practice_ID === cur_box.practice_ID) {
                chkbox.isSelected = value;
              }
            });
          }
        } else if ($scope.showCategories) {
          $scope.updatedData.element = $scope.element;
          value = event.target.checked;
          $scope.updatedData.data.forEach(function(chkbox, index, array) {
            if (chkbox.cat_ID === cur_box.cat_ID) {
              chkbox.isSelected = value;
            }
          });
        }
      };
      $scope.displaySubPracticeAreas = function(law_area) {
        return law_area.showSubPracticeAreas = true;
      };
      $scope.hideSubPracticeAreas = function(law_area) {
        return law_area.showSubPracticeAreas = false;
      };
      $scope.displayChildLocations = function(region) {
        $log.info("plus clicked");
        return region.showChildLocations = true;
      };
      $scope.hideChildLocations = function(region) {
        $log.info("minus clicked");
        return region.showChildLocations = false;
      };
      $scope.selectPractices = function(event, current, level) {
        let message, pCounter, sCounter, value;
        $log.info("law_area selected on signup profile");
        $log.info(current);
        pCounter = 0;
        sCounter = 0;
        $scope.updatedData.element = 'practice';
        value = event.target.checked;
        if ($scope.count >= 20 && value) {
          message = 'You are allowed to choose a maximum of 20 practice areas.';
          logger.notify('error', message);
          event.target.checked = false;
          return false;
        } else {
          if (level === 2) {
            $scope.updatedData.data.forEach(function(law_area, index, array) {
              if (law_area.practice_ID === current.practice_ID) {
                law_area.isSelected = value;
                if (law_area.practices.length > 0) {
                  law_area.practices.forEach(function(practice, index, array) {
                    if (practice.sub_areas.length > 0 && $scope.count < 20) {
                      practice.isSelected = value;
                      practice.sub_areas.forEach(function(sub, index, array) {
                        if (sub.isSelected !== value) {
                          if ($scope.count < 20 && value) {
                            sub.isSelected = value;
                            $scope.count++;
                          } else if (!value) {
                            sub.isSelected = value;
                            $scope.count--;
                          }
                        }
                      });
                    } else {
                      if ($scope.count < 20 && value) {
                        practice.isSelected = value;
                        $scope.count++;
                      } else if (!value && practice.isSelected) {
                        practice.isSelected = value;
                        $scope.count--;
                      }
                    }
                  });
                } else {
                  if (value && $scope.count < 20) {
                    law_area.isSelected = value;
                    $scope.count++;
                  } else if (!value) {
                    law_area.isSelected = value;
                    $scope.count--;
                  }
                }

                practicesService.checkForLinking(
                  $scope.updatedData.data,
                  current.practice_ID,
                  value
                );
              }
            });
            // return;
          } else if (level === 1) {
            $scope.updatedData.data.forEach(function(law_area, index, array) {
              return law_area.practices.forEach(function(practice, index, array) {
                if (practice.practice_ID === current.practice_ID) {
                  $log.info("level 1 pa selected");
                  $log.info(practice);
                  if (practice.sub_areas.length > 0) {
                    practice.isSelected = value;
                    law_area.practices.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++;
                      }
                    });
                    if (value) {
                      if (pCounter > 0) {
                        law_area.isSelected = value;
                      }
                    } else {
                      if (pCounter <= 0) {
                        law_area.isSelected = value;
                      }
                    }
                    practice.sub_areas.forEach(function(sub, index, array) {
                      if (sub.isSelected !== value) {
                        if ($scope.count < 20 && value) {
                          sub.isSelected = value;
                          $scope.count++;
                        } else if (!value) {
                          if (sub.isSelected) {
                            sub.isSelected = value;
                            $scope.count--;
                          }
                        }
                      }
                    });
                  } else {
                    if ($scope.count < 20 && value) {
                      $log.info("updating checked value");
                      practice.isSelected = value;
                      law_area.practices.forEach(function(p, i, a) {
                        if (p.isSelected) {
                          pCounter++;
                        }
                      });
                      if (value) {
                        if (pCounter > 0) {
                          law_area.isSelected = value;
                        }
                      } else {
                        if (pCounter <= 0) {
                          law_area.isSelected = value;
                        }
                      }
                      $scope.count++;
                    } else if (!value) {
                      practice.isSelected = value;
                      law_area.practices.forEach(function(p, i, a) {
                        if (p.isSelected) {
                          pCounter++;
                        }
                      });
                      if (value) {
                        if (pCounter > 0) {
                          law_area.isSelected = value;
                        }
                      } else {
                        if (pCounter <= 0) {
                          law_area.isSelected = value;
                        }
                      }
                      $scope.count--;
                    }
                  }

                  practicesService.checkForLinking(
                    $scope.updatedData.data,
                    current.practice_ID,
                    value
                  );
                }
              });
            });
            // return;
          } else if (level === 0) {
            $scope.updatedData.data.forEach(function(law_area, index, array) {
              law_area.practices.forEach(function(practice, index, array) {
                if (practice.sub_areas.length > 0) {
                  practice.sub_areas.forEach(function(sub, index, array) {
                    if (sub.practice_ID === current.practice_ID) {
                      sub.isSelected = value;
                      practice.sub_areas.forEach(function(s, i, a) {
                        if (s.isSelected) {
                          sCounter++;
                        }
                      });
                      if (value) {
                        if (sCounter > 0) {
                          law_area.isSelected = value;
                          practice.isSelected = value;
                        }
                      } else {
                        if (sCounter <= 0) {
                          practice.isSelected = value;
                          law_area.practices.forEach(function(p, i, a) {
                            if (p.isSelected) {
                              pCounter++;
                            }
                          });
                          if (value) {
                            if (pCounter > 0) {
                              law_area.isSelected = value;
                            }
                          } else {
                            if (pCounter <= 0) {
                              law_area.isSelected = value;
                            }
                          }
                        }
                      }
                      if (value) {
                        $scope.count++;
                      } else {
                        $scope.count--;
                      }

                      practicesService.checkForLinking(
                        $scope.updatedData.data,
                        current.practice_ID,
                        value
                      );
                    }
                  });
                }
              });
            });
          }
          if ($scope.count === 20) {
              message = 'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.';
              logger.notify('warning', message);
          } else if ($scope.count === 15) {
              message = 'You are approaching the limit for practice area selections';
              logger.notify('warning', message);
          }
        }
      };

      $scope.selectLocation = function(event, current, level) {
        var pCounter, sCounter, value;
        pCounter = 0;
        sCounter = 0;
        $scope.updatedData.element = 'location';
        value = event.target.checked;
        if (level === 2) {
          $scope.updatedData.data.forEach(function(region, index, array) {
            if (region.loc_ID === current.loc_ID) {
              region.isSelected = value;
              if (region.locations.length > 0) {
                region.locations.forEach(function(location, index, array) {
                  location.isSelected = value;
                  location.sub_areas.forEach(function(sub, index, array) {
                    if (sub.isSelected !== value) {
                      if (value) {
                        sub.isSelected = value;
                      } else if (!value) {
                        sub.isSelected = value;
                      }
                    }
                  });
                  if (value) {
                    return location.isSelected = value;
                  } else if (!value && location.isSelected) {
                    return location.isSelected = value;
                  }
                });
              } else {
                if (value) {
                  return region.isSelected = value;
                } else if (!value) {
                  return region.isSelected = value;
                }
              }
            }
          });
          return;
        } else if (level === 1) {
          $scope.updatedData.data.forEach(function(region, index, array) {
            return region.locations.forEach(function(location, index, array) {
              if (location.loc_ID === current.loc_ID) {
                if (location.sub_areas.length > 0) {
                  location.isSelected = value;
                  region.locations.forEach(function(p, i, a) {
                    if (p.isSelected) {
                      pCounter++;
                    }
                  });
                  if (value) {
                    if (pCounter > 0) {
                      region.isSelected = value;
                    }
                  } else {
                    if (pCounter <= 0) {
                      region.isSelected = value;
                    }
                  }
                  location.sub_areas.forEach(function(sub, index, array) {
                    if (sub.isSelected !== value) {
                      if (value) {
                        sub.isSelected = value;
                      } else if (!value) {
                        if (sub.isSelected) {
                          sub.isSelected = value;
                        }
                      }
                    }
                  });
                } else {
                  if (value) {
                    location.isSelected = value;
                    region.locations.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++;
                      }
                    });
                    if (value) {
                      if (pCounter > 0) {
                        region.isSelected = value;
                      }
                    } else {
                      if (pCounter <= 0) {
                        region.isSelected = value;
                      }
                    }
                  } else if (!value) {
                    location.isSelected = value;
                    region.locations.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++;
                      }
                    });
                    if (value) {
                      if (pCounter > 0) {
                        region.isSelected = value;
                      }
                    } else {
                      if (pCounter <= 0) {
                        region.isSelected = value;
                      }
                    }
                  }
                }
              }
            });
          });
          return;
        } else if (level === 0) {
          $scope.updatedData.data.forEach(function(region, index, array) {
            region.locations.forEach(function(location, index, array) {
              if (location.sub_areas.length > 0) {
                location.sub_areas.forEach(function(sub, index, array) {
                  if (sub.loc_ID === current.loc_ID) {
                    sub.isSelected = value;
                    location.sub_areas.forEach(function(s, i, a) {
                      if (s.isSelected) {
                        sCounter++;
                      }
                    });
                    if (value) {
                      if (sCounter > 0) {
                        region.isSelected = value;
                        location.isSelected = value;
                      }
                    } else {
                      if (sCounter <= 0) {
                        location.isSelected = value;
                        region.locations.forEach(function(p, i, a) {
                          if (p.isSelected) {
                            pCounter++;
                          }
                        });
                        if (value) {
                          if (pCounter > 0) {
                            region.isSelected = value;
                          }
                        } else {
                          if (pCounter <= 0) {
                            region.isSelected = value;
                          }
                        }
                      }
                    }
                  }
                });
              }
            });
          });
        }
      };
      $scope.countCheckbox = function(value, level) {
        if (value) {
          $scope.count++;
        } else if (!value) {
          $scope.count--;
        }
      };
      $scope.selectAll = function(event) {
        let mainCheckBox, message, value;
        mainCheckBox = event.target.attributes.data.value;
        value = event.target.checked;
        if (value) {
          if ($scope.count > 20) {
              message = 'You are allowed to choose a maximum of 20 practice areas.';
              logger.notify('error', message);
              event.target.checked = false;
              return false;
          } else if ($scope.count <= 20) {
            if ($scope.count === 20) {
                message = 'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.';
                logger.notify('warning', message);
            } else if ($scope.count === 15) {
                message = 'You are approaching the limit for practice area selections.';
                logger.notify('warning', message);
            }

            $scope.data.forEach(function(chkbox, index, array) {
              if (chkbox.lawArea_ID === parseInt(mainCheckBox) && !chkbox.isSelected && $scope.count < 20) {
                $scope.countCheckbox(value, 1);
                chkbox.isSelected = value;
              }
            });
          }
        } else {
          $scope.data.forEach(function(chkbox, index, array) {
            if (chkbox.lawArea_ID === parseInt(mainCheckBox) && chkbox.isSelected) {
              $scope.countCheckbox(value, 1);
              chkbox.isSelected = value;
            }
          });
        }
      };
      $scope.save = function() {
          determineWhetherToDisplayNextSelectionOrClose();
      };
      $scope.cancel = function() {
        // determine if locations settings are displayed then
        // the user might have tried to update Practice Areas
        // so save them and hide the form
        if($scope.hasUserMadeAnyUpdates) closeModalWithData($scope.updatedData);
        // just close the modal
        else $modalInstance.dismiss("cancel");
      };
    }
  ]);
}());


// WEBPACK FOOTER //
// ./scripts/shared/CreateProfileModalCtrl.js